import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from 'recharts';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface DropoutBarChartProps {
  dropOutData: { page: string | number; count: number }[];
}

const DropoutBarChart: React.FC<DropoutBarChartProps> = ({ dropOutData }) => (
  <DashboardChartBox>
    <HeaderTitle>
      <p>Drop-out Count Per Page</p>
    </HeaderTitle>
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={dropOutData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 60,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="page"
          label={{
            value: 'Page Number',
            position: 'insideBottom',
            offset: -10,
          }}
        />
        <YAxis
          label={{
            value: 'Count',
            angle: -90,
            position: 'insideLeft',
          }}
        />
        <Tooltip labelFormatter={label => `Page ${label}`} />
        <Legend
          verticalAlign="bottom"
          align="center"
          height={36}
          wrapperStyle={{
            bottom: 0,
            paddingTop: 20,
            paddingBottom: 10,
          }}
        />
        <Bar name="Count Drop-out" dataKey="count" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  </DashboardChartBox>
);

export default DropoutBarChart;
